import React from "react";
import BaseModal from "../../components/BaseModal";
import DescriptionFeedbackModal from "./DescriptionFeedbackModal";
import BaseButton from "../../components/BaseButton";
import useController from "./controller";
import { MODAL_TYPES } from "../../utils/emitter";
import "./style.scss";
import { useTranslation } from "react-i18next";
import BaseIcon from "../../components/BaseIcon";

export default function FeedbackModal() {
  const { share } = useController();
  const { t } = useTranslation();

  return (
    <BaseModal
      eventTypeModal={MODAL_TYPES.FEEDBACK_MODAL}
      description={<DescriptionFeedbackModal />}
      contentStyle="feedback-modal-content"
      className="feedback-modal big-mobile-modal"
    >
      <BaseButton onClick={share} className="feedback-modal__form__copy">
        <BaseIcon
          name={"share_gradient_white"}
          className="feedback-modal__form__copy--icon"
        />
        {t("feedback.share")}
      </BaseButton>
      {/*{isCopy && <div className="feedback-modal__form__copy-link">{t("feedback.copy-link")}</div>}*/}
    </BaseModal>
  );
}
